<template>
  <div id="bottomRight">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span style="color: #5cd9e8">
          <!-- <icon name="chart-area"></icon> -->
          <i class="iconfont iconliuliang"></i>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">车流量Top5</span>
          <div class="decoration2"></div>
        </div>
      </div>
      <div class="d-flex jc-center">
        <Echart
          :options="options"
          id="bottomRightEcharts"
          height="100%"
          width="100%"
        ></Echart>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from "@/common/echart";

export default {
  data() {
    return {
      options: {},
      cost:[],
      grade:[],
      sixInterval:""
    };
  },
  components: {
    Echart,
  },
  mounted() {
    this.dataList();
    this.submitGetMessageList()
  },
  methods: {
    dataList() {
      var cost = this.cost; //本期比上期（大于1按1处理）
      var grade = this.grade;
      var myColor = ["#21BF57", "#56D0E3", "#1089E7", "#F8B448", "#F57474"];
      var data = {
        grade: grade,
        cost: cost,
      };
      this.options = {
        title: {
          textStyle: {
            align: "center",
            color: "#4DCEF8",
            fontSize: 18,
          },
        },
        grid: {
          left: "130",
          right: "10",
          top: "10",
          bottom: "10",
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          type: "category",
          axisLabel: {
            margin: 20,
            show: true,
            color: "#4DCEF8",
            fontSize: 14,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          data: data.grade,
        },
        series: [
          {
            type: "bar",
            barGap: "-85%",
            barWidth: "30%",
            itemStyle: {
              normal: {
                barBorderRadius: 16,
                color: function (params) {
                  var num = myColor.length;
                  return myColor[params.dataIndex % num];
                },
              },
            },
            max: 1,
            label: {
              normal: {
                show: true,
                position: "inside",
                formatter: "{c}",
              },
            },
            labelLine: {
              show: true,
            },
            z: 2,
            data: data.cost,
          },
        ],
      };
    },
    submitGetMessageList() {
      const that = this;
      that.$store.dispatch("getMessageList", 6); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
      that.sixInterval =  setInterval(() => {
        that.$store.dispatch("getMessageList", 6); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
      }, 10000);
    },
  },
  beforeDestroy () {
    clearInterval(this.sixInterval);
    this.sixInterval = null;
  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    //监听vuex中reailTimeToal的变化
    "$store.state.flowTopList"(val) {
      //变化之后根据自己项目需求写自身的逻辑代码，下面只是示例
      var data = val.flowTopList;
      var cost = [];
      var grade = [];
      for(var i = 4;i>=0;i--){
        cost.push(data[i].num);
        grade.push(data[i].parkName);
      };
      this.cost = cost;
      this.grade = grade;
      this.dataList();
    },
  },
};
</script>

<style lang="scss">
#bottomRight {
  // padding: 0.1rem;
  width: 100%;
  height: 100%;
  border-radius: 0.0625rem;
  .bg-color-black {
    height: 6.1875rem;
    border-radius: 0.125rem;
    .jc-center {
      height: 90%;
    }

    #bottomRightEcharts {
      width: 100%;
      height: 100%;
    }
  }
  .text {
    color: #c3cbde;
  } //下滑线动态
  .decoration2 {
    position: absolute;
    right: 0.125rem;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>